import React, { FC } from 'react';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import styles from '../../activityDataEntry.module.scss';
import COSelect from 'shared/components/COSelect';
import { Scope1DesiredData } from 'models/ActivityDataScope1DesiredData/scope1DesiredData.model';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { naturalGasUnitOptions } from '..';
import { useFormikContext } from 'formik';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { convertToReadableText } from 'shared/utils/convertToUserReadable';
import { allowOnlyNumbers } from 'shared/utils/convertFormData';

interface StationaryCombustionFieldsProps {
  handleToolTipOpen: (fieldName?: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string,
    selectedItemIndex?: number
  ) => () => void;
}

const StationaryCombustionFields: FC<StationaryCombustionFieldsProps> = ({
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
}) => {
  const { values } = useFormikContext<Scope1DesiredData>();
  return (
    <Row gutter={[24, 40]} className={styles.stationaryFormConatiner}>
      {values?.stationaryCombustion?.map((source, index) => {
        if (source?.fuelName === HelpDeskInputFieldEnum.NATURAL_GAS) {
          return (
            <Col span={12} key={source?.fuelName}>
              <div className={styles.fieldContainer}>
                <Col span={9}>
                  <InputField
                    name={`stationaryCombustion.${index}.fuelValue`}
                    placeholderstring={source?.getPlaceholder?.() ?? ''}
                    label={source?.getPlaceholder?.() ?? ''}
                    info
                    infoClick={handleToolTipOpen(
                      convertToReadableText(
                        source?.fuelName
                      ) as HelpDeskInputFieldEnum
                    )}
                    disabled={
                      !isEditView ||
                      !values?.stationaryCombustion?.[index].isYearly
                    }
                    onKeyDown={allowOnlyNumbers}
                    isNullable={true}
                  />
                </Col>
                {values?.stationaryCombustion?.[index].isYearly && (
                  <Col span={7}>
                    <COSelect
                      name={`stationaryCombustion.${index}.unit`}
                      placeholderstring="Units"
                      label="Units"
                      options={naturalGasUnitOptions}
                      disabled={!isEditView}
                      allowClear={false}
                    />
                  </Col>
                )}
                {!values?.stationaryCombustion?.[index].isYearly && (
                  <>
                    <Col span={7}>
                      <p
                        className={styles.viewMonthlyText}
                        onClick={handleMonthlyModalOpen(
                          values?.stationaryCombustion?.[index],
                          'stationaryCombustion',
                          `stationaryCombustion[${index}]`
                        )}>
                        View Monthly data
                      </p>
                    </Col>
                    {isEditView && (
                      <span className={styles.pipeSeperator}> | </span>
                    )}
                  </>
                )}
                {isEditView && (
                  <Col span={8}>
                    <p
                      className={styles.monthlyText}
                      onClick={handleSwitch(
                        values?.stationaryCombustion?.[index],
                        'stationaryCombustion',
                        `stationaryCombustion[${index}]`
                      )}>
                      {values?.stationaryCombustion?.[index].isYearly
                        ? 'Switch to monthly'
                        : 'Switch to annually'}
                    </p>
                  </Col>
                )}
              </div>
            </Col>
          );
        } else {
          return (
            <Col span={12} key={source?.fuelName}>
              <div className={styles.fieldContainer}>
                <Col
                  span={
                    values?.stationaryCombustion?.[index].isYearly ? 16 : 9
                  }>
                  <InputField
                    name={`stationaryCombustion.${index}.fuelValue`}
                    placeholderstring={source?.getPlaceholder?.() ?? ''}
                    label={source.getPlaceholder?.() ?? ''}
                    info
                    infoClick={handleToolTipOpen(
                      convertToReadableText(
                        source?.fuelName
                      ) as HelpDeskInputFieldEnum
                    )}
                    disabled={
                      !isEditView ||
                      !values?.stationaryCombustion?.[index].isYearly
                    }
                    onKeyDown={allowOnlyNumbers}
                    isNullable={true}
                  />
                </Col>
                {!values?.stationaryCombustion?.[index].isYearly && (
                  <>
                    <Col span={7}>
                      <p
                        className={styles.viewMonthlyText}
                        onClick={handleMonthlyModalOpen(
                          values?.stationaryCombustion?.[index],
                          'stationaryCombustion',
                          `stationaryCombustion[${index}]`
                        )}>
                        View Monthly data
                      </p>
                    </Col>
                    {isEditView && (
                      <span className={styles.pipeSeperator}> | </span>
                    )}
                  </>
                )}
                {isEditView && (
                  <Col span={8}>
                    <p
                      className={styles.monthlyText}
                      onClick={handleSwitch(
                        values?.stationaryCombustion?.[index],
                        'stationaryCombustion',
                        `stationaryCombustion[${index}]`
                      )}>
                      {values?.stationaryCombustion?.[index].isYearly
                        ? 'Switch to monthly'
                        : 'Switch to annually'}
                    </p>
                  </Col>
                )}
              </div>
            </Col>
          );
        }
      })}
    </Row>
  );
};

export default StationaryCombustionFields;
